<template>
  <v-container pb-0>
    <div class="inline">
      <div class="filter-panel-outer hidden-sm-and-down" ref="filterPanelOuter">
        <!--TODO: add the fixed element in here so that we can get what width it need to be from the parent div-->

          <v-layout column align-start align-content-start justify-start class="filter-panel-inner">
            <h2>{{$t('filter_interventions_title')}}</h2>
            <interactions-filter/>
          </v-layout>

      </div>
      <div class="content-panel">
        <FilteredTable id="interactionsPageFilter">
          <v-layout column slot="page-heading">
            <h1>{{$t('interventions_page_title')}}</h1>
            <custom-text msg="custom-text.interactions" class="mt-2 mb-1"></custom-text>
          </v-layout>
          <div slot="header" key="main-content" slot-scope="props">
            <v-layout row wrap>
              <v-flex xs8 sm6>
                <v-select id="interventions_sort"
                          attach
                          :items="sortFields"
                          hide-details
                          v-model="sortBy"
                          :label="$t('select_sorting')"/>
              </v-flex>
              <template v-if="$vuetify.breakpoint.smAndUp || !props.isFixed">
                <v-flex xs6 mt-3 align-self-center class="hidden-sm-and-up">
                  {{$t('results', {count: totalElements}, totalElements)}}
                </v-flex>
                <v-flex text-xs-right sm6 xs6 v-if="$vuetify.breakpoint.mdAndUp">
                  <v-btn color="primary" class="primary-text" @click="createIntervention">
                    <v-icon left>mdi-account-multiple</v-icon>
                    <span>{{$t('interactions_create_intervention')}}</span>
                  </v-btn>
                  <v-btn color="primary" class="primary-text" @click="createExemption">
                    <v-icon left>timelapse</v-icon>
                    <span>{{$t('interactions_create_exemption')}}</span>
                  </v-btn>
                </v-flex>
              </template>
            </v-layout>
            <v-layout row wrap class="hidden-xs-only">
              <v-flex sm3 xs6 mt-2 align-self-center>
                {{$t('results', {count: totalElements}, totalElements)}}
              </v-flex>
            </v-layout>
            <v-progress-linear v-if="loading" height="2" :indeterminate="true" color="accent"/>

          </div>
          <tutor-interactions slot="table"/>
        </FilteredTable>
      </div>
    </div>
    <fab-dial v-if="$vuetify.breakpoint.smAndDown" :buttons="buttons" :nudge-bottom="nudgeBottom"
              :color="$vuetify.theme.secondary"/>
  </v-container>
</template>

<script>
  import TutorInteractions from './TutorInteractions'
  import FilteredTable from '../FilteredTable'
  import { mapMutations, mapState } from 'vuex'
  import { CHANGE_INTERACTIONS_SORTING } from '../../store/action-types'
  import {
    RESET_EXEMPTION_MODULE,
    RESET_INTERVENTION_MODULE,
    SET_DRAWER_COMPONENT,
    SET_DRAWER_STATE,
    SET_DRAWER_COMPONENT_TITLE,
    SET_INFORMATION_DISPLAYED_LIST
  } from '../../store/mutation-types'
  import { listNames } from '../../store/modules/information'
  import InteractionsFilter from './InteractionsFilter'
  import { components, componentTitles } from '../../store/modules/rightDrawer'
  import FabDial from '../misc/fab/FabDial'
  import colors from 'vuetify/es5/util/colors'
  import CustomText from '../help/CustomText'

  export default {
    name: 'InteractionsPage',
    computed: {
      ...mapState({
        stateSortFields: state => state.interactions.sortFields,
        totalElements: state => state.interactions.totalElements,
        loading: state => state.interactions.loading,
        nudgeBottom: state => state.undo.state
      }),
      sortFields () {
        return this.stateSortFields.map(field => {
          return {
            'text': this.$t(field.text),
            'value': field.value
          }
        })
      },
      sortBy: {
        get () {
          return this.$store.state.interactions.sortBy
        },
        set (value) {
          this.$store.dispatch(CHANGE_INTERACTIONS_SORTING, value)
        }
      }
    },
    data () {
      return {
        buttons: [
          {
            icon: 'filter_list',
            text: this.$t('interactions_filters'),
            color: this.$vuetify.theme.secondary,
            action: this.showFilter
          },
          {
            icon: 'mdi-account-multiple',
            text: this.$t('interactions_create_intervention'),
            color: colors.deepOrange.darken2,
            action: this.createIntervention
          },
          {
            icon: 'timelapse',
            text: this.$t('interactions_create_exemption'),
            color: colors.green.darken2,
            action: this.createExemption
          }]
      }
    },
    mounted () {
      this.$store.commit(SET_INFORMATION_DISPLAYED_LIST, listNames.INTERACTIONS)
    },
    methods: {
      createIntervention () {
        this.resetIntervention()
        this.setDrawerComponent(components.CREATE_INTERVENTION)
        this.setDrawerComponentTitle(componentTitles.CREATE_INTERVENTION)
        this.setDrawerState(true)
      },
      createExemption () {
        this.setDrawerComponent(components.CREATE_EXEMPTION)
        this.setDrawerComponentTitle(componentTitles.CREATE_EXEMPTION)
        // Currently re-using intervention for exemption
        this.resetIntervention()
        this.resetExemption()
        this.setDrawerState(true)
      },
      showFilter () {
        this.setDrawerComponent(components.INTERACTION_FILTER)
        this.setDrawerComponentTitle(componentTitles.INTERACTION_FILTER)
        this.setDrawerState(true)
      },
      ...mapMutations({
        setDrawerComponent: SET_DRAWER_COMPONENT,
        setDrawerComponentTitle: SET_DRAWER_COMPONENT_TITLE,
        setDrawerState: SET_DRAWER_STATE,
        resetIntervention: RESET_INTERVENTION_MODULE,
        resetExemption: RESET_EXEMPTION_MODULE
      })
    },
    components: {
      FabDial,
      TutorInteractions,
      FilteredTable,
      InteractionsFilter,
      CustomText
    }
  }
</script>

<style scoped>
  .progress-linear {
    margin: -5px 0 0;
  }

  .inline {
    display: flex;
  }

  .content-panel {
    flex: 10 10 0;
  }

  .filter-panel-outer {
    flex: 3 3 0;
  }

  .filter-panel-inner {
    position: -webkit-sticky;
    position: sticky;
    top: 64px;
    padding: 8px 8px 0px 0px;
  }

  .btn {
    width:100%;
    max-width: 250px;
    justify-content: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/intervention/InteractionsPage.vue